/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "zh-Hans-HK": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-short": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "quarter": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-short": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-narrow": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "month": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-short": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-narrow": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "week": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-short": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-narrow": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "day": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-short": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-narrow": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "hour": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-short": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-narrow": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "minute": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-short": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-narrow": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "second": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        },
        "second-short": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        },
        "second-narrow": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        }
      },
      "zh-Hans-MO": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-short": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "quarter": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-short": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-narrow": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "month": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-short": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-narrow": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "week": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-short": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-narrow": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "day": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-short": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-narrow": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "hour": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-short": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-narrow": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "minute": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-short": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-narrow": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "second": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        },
        "second-short": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        },
        "second-narrow": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        }
      },
      "zh-Hans-SG": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-short": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "quarter": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-short": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-narrow": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "month": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-short": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-narrow": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "week": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-short": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-narrow": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "day": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-short": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-narrow": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "hour": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-short": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-narrow": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "minute": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-short": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-narrow": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "second": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        },
        "second-short": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        },
        "second-narrow": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        }
      },
      "zh-Hans": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-short": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "quarter": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-short": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-narrow": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "month": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-short": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-narrow": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "week": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-short": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-narrow": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "day": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-short": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-narrow": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "hour": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-short": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-narrow": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "minute": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-short": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-narrow": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "second": {
          "0": "现在",
          "future": {
            "other": "{0}秒钟后"
          },
          "past": {
            "other": "{0}秒钟前"
          }
        },
        "second-short": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        },
        "second-narrow": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        }
      },
      "zh-Hant-HK": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "上年"
        },
        "year-short": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "上年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0}年後"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "上年"
        },
        "quarter": {
          "0": "今季",
          "1": "下一季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上一季"
        },
        "quarter-short": {
          "0": "今季",
          "1": "下季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上季"
        },
        "quarter-narrow": {
          "0": "今季",
          "1": "下季",
          "future": {
            "other": "+{0}Q"
          },
          "past": {
            "other": "-{0}Q"
          },
          "-1": "上季"
        },
        "month": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "month-short": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "month-narrow": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0}個月後"
          },
          "past": {
            "other": "{0}個月前"
          },
          "-1": "上個月"
        },
        "week": {
          "0": "本星期",
          "1": "下星期",
          "future": {
            "other": "{0} 星期後"
          },
          "past": {
            "other": "{0} 星期前"
          },
          "-1": "上星期"
        },
        "week-short": {
          "0": "本星期",
          "1": "下星期",
          "future": {
            "other": "{0} 星期後"
          },
          "past": {
            "other": "{0} 星期前"
          },
          "-1": "上星期"
        },
        "week-narrow": {
          "0": "本星期",
          "1": "下星期",
          "future": {
            "other": "{0}星期後"
          },
          "past": {
            "other": "{0}星期前"
          },
          "-1": "上星期"
        },
        "day": {
          "0": "今日",
          "1": "明日",
          "2": "後日",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前日",
          "-1": "昨日"
        },
        "day-short": {
          "0": "今日",
          "1": "明日",
          "2": "後日",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前日",
          "-1": "昨日"
        },
        "day-narrow": {
          "0": "今日",
          "1": "明日",
          "2": "後日",
          "future": {
            "other": "{0}日後"
          },
          "past": {
            "other": "{0}日前"
          },
          "-2": "前日",
          "-1": "昨日"
        },
        "hour": {
          "0": "這個小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "hour-short": {
          "0": "這個小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "hour-narrow": {
          "0": "這個小時",
          "future": {
            "other": "{0}小時後"
          },
          "past": {
            "other": "{0}小時前"
          }
        },
        "minute": {
          "0": "這分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "minute-short": {
          "0": "這分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "minute-narrow": {
          "0": "這分鐘",
          "future": {
            "other": "{0}分後"
          },
          "past": {
            "other": "{0}分前"
          }
        },
        "second": {
          "0": "現在",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-short": {
          "0": "現在",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-narrow": {
          "0": "現在",
          "future": {
            "other": "{0}秒後"
          },
          "past": {
            "other": "{0}秒前"
          }
        }
      },
      "zh-Hant-MO": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "上年"
        },
        "year-short": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "上年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0}年後"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "上年"
        },
        "quarter": {
          "0": "今季",
          "1": "下一季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上一季"
        },
        "quarter-short": {
          "0": "今季",
          "1": "下季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上季"
        },
        "quarter-narrow": {
          "0": "今季",
          "1": "下季",
          "future": {
            "other": "+{0}Q"
          },
          "past": {
            "other": "-{0}Q"
          },
          "-1": "上季"
        },
        "month": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "month-short": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "month-narrow": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0}個月後"
          },
          "past": {
            "other": "{0}個月前"
          },
          "-1": "上個月"
        },
        "week": {
          "0": "本星期",
          "1": "下星期",
          "future": {
            "other": "{0} 星期後"
          },
          "past": {
            "other": "{0} 星期前"
          },
          "-1": "上星期"
        },
        "week-short": {
          "0": "本星期",
          "1": "下星期",
          "future": {
            "other": "{0} 星期後"
          },
          "past": {
            "other": "{0} 星期前"
          },
          "-1": "上星期"
        },
        "week-narrow": {
          "0": "本星期",
          "1": "下星期",
          "future": {
            "other": "{0}星期後"
          },
          "past": {
            "other": "{0}星期前"
          },
          "-1": "上星期"
        },
        "day": {
          "0": "今日",
          "1": "明日",
          "2": "後日",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前日",
          "-1": "昨日"
        },
        "day-short": {
          "0": "今日",
          "1": "明日",
          "2": "後日",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前日",
          "-1": "昨日"
        },
        "day-narrow": {
          "0": "今日",
          "1": "明日",
          "2": "後日",
          "future": {
            "other": "{0}日後"
          },
          "past": {
            "other": "{0}日前"
          },
          "-2": "前日",
          "-1": "昨日"
        },
        "hour": {
          "0": "這個小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "hour-short": {
          "0": "這個小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "hour-narrow": {
          "0": "這個小時",
          "future": {
            "other": "{0}小時後"
          },
          "past": {
            "other": "{0}小時前"
          }
        },
        "minute": {
          "0": "這分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "minute-short": {
          "0": "這分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "minute-narrow": {
          "0": "這分鐘",
          "future": {
            "other": "{0}分後"
          },
          "past": {
            "other": "{0}分前"
          }
        },
        "second": {
          "0": "現在",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-short": {
          "0": "現在",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-narrow": {
          "0": "現在",
          "future": {
            "other": "{0}秒後"
          },
          "past": {
            "other": "{0}秒前"
          }
        }
      },
      "zh-Hant": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "去年"
        },
        "year-short": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "去年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "去年"
        },
        "quarter": {
          "0": "這一季",
          "1": "下一季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上一季"
        },
        "quarter-short": {
          "0": "這一季",
          "1": "下一季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上一季"
        },
        "quarter-narrow": {
          "0": "這一季",
          "1": "下一季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上一季"
        },
        "month": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "month-short": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "month-narrow": {
          "0": "本月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "week": {
          "0": "本週",
          "1": "下週",
          "future": {
            "other": "{0} 週後"
          },
          "past": {
            "other": "{0} 週前"
          },
          "-1": "上週"
        },
        "week-short": {
          "0": "本週",
          "1": "下週",
          "future": {
            "other": "{0} 週後"
          },
          "past": {
            "other": "{0} 週前"
          },
          "-1": "上週"
        },
        "week-narrow": {
          "0": "本週",
          "1": "下週",
          "future": {
            "other": "{0} 週後"
          },
          "past": {
            "other": "{0} 週前"
          },
          "-1": "上週"
        },
        "day": {
          "0": "今天",
          "1": "明天",
          "2": "後天",
          "future": {
            "other": "{0} 天後"
          },
          "past": {
            "other": "{0} 天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-short": {
          "0": "今天",
          "1": "明天",
          "2": "後天",
          "future": {
            "other": "{0} 天後"
          },
          "past": {
            "other": "{0} 天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-narrow": {
          "0": "今天",
          "1": "明天",
          "2": "後天",
          "future": {
            "other": "{0} 天後"
          },
          "past": {
            "other": "{0} 天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "hour": {
          "0": "這一小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "hour-short": {
          "0": "這一小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "hour-narrow": {
          "0": "這一小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "minute": {
          "0": "這一分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "minute-short": {
          "0": "這一分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "minute-narrow": {
          "0": "這一分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "second": {
          "0": "現在",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-short": {
          "0": "現在",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-narrow": {
          "0": "現在",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        }
      },
      "zh": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-short": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "明年",
          "future": {
            "other": "{0}年后"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "去年"
        },
        "quarter": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-short": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "quarter-narrow": {
          "0": "本季度",
          "1": "下季度",
          "future": {
            "other": "{0}个季度后"
          },
          "past": {
            "other": "{0}个季度前"
          },
          "-1": "上季度"
        },
        "month": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-short": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "month-narrow": {
          "0": "本月",
          "1": "下个月",
          "future": {
            "other": "{0}个月后"
          },
          "past": {
            "other": "{0}个月前"
          },
          "-1": "上个月"
        },
        "week": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-short": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "week-narrow": {
          "0": "本周",
          "1": "下周",
          "future": {
            "other": "{0}周后"
          },
          "past": {
            "other": "{0}周前"
          },
          "-1": "上周"
        },
        "day": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-short": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "day-narrow": {
          "0": "今天",
          "1": "明天",
          "2": "后天",
          "future": {
            "other": "{0}天后"
          },
          "past": {
            "other": "{0}天前"
          },
          "-2": "前天",
          "-1": "昨天"
        },
        "hour": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-short": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "hour-narrow": {
          "0": "这一时间 / 此时",
          "future": {
            "other": "{0}小时后"
          },
          "past": {
            "other": "{0}小时前"
          }
        },
        "minute": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-short": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "minute-narrow": {
          "0": "此刻",
          "future": {
            "other": "{0}分钟后"
          },
          "past": {
            "other": "{0}分钟前"
          }
        },
        "second": {
          "0": "现在",
          "future": {
            "other": "{0}秒钟后"
          },
          "past": {
            "other": "{0}秒钟前"
          }
        },
        "second-short": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        },
        "second-narrow": {
          "0": "现在",
          "future": {
            "other": "{0}秒后"
          },
          "past": {
            "other": "{0}秒前"
          }
        }
      }
    },
    "availableLocales": ["zh-Hans-HK", "zh-Hans-MO", "zh-Hans-SG", "zh-Hans", "zh-Hant-HK", "zh-Hant-MO", "zh-Hant", "zh"]
  });
}